// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__zaRbw","topBottomGutter":"Layout_topBottomGutter__1A8qW"};